const MP4_EXTENSION_PATTERN = /\.mp4(?:$|[?#])/i;

export const isMp4Media = (media?: string | File | null): boolean => {
  if (!media) return false;

  if (media instanceof File) {
    return media.type.toLowerCase() === "video/mp4" ||
      MP4_EXTENSION_PATTERN.test(media.name);
  }

  return MP4_EXTENSION_PATTERN.test(media);
};
